function HandleBundleCTAClick( e )
{
    e.preventDefault();

    CheckChildInputsAreNotEmpty();
    return true;
}

function HandleBundlePillClick( e )
{
    var pillsContainer = e.currentTarget.nextElementSibling;
    pillsContainer.classList.remove( "hidden" );
}

function CheckChildInputsAreNotEmpty()
{
    var inputs = document.querySelectorAll( ".lightning-bundle-child-product-input" );
    for( var i = 0; i < inputs.length; i++ )
    {
        var input = inputs[ i ];
        if( input.value == "" )
        {
            var selectForInput = document.querySelector( ".lightning-bundle-option-select[data-bundle-option='" + input.dataset.bundleOption + "']" );
            input.value = selectForInput.querySelector( "option" ).value;
        }
    }
}

function CreateSkuDisplayProperties()
{
    var inputs     = document.querySelectorAll( ".lightning-bundle-child-product-display" );
    inputs.forEach( function( input )
    {
        input.remove();
    });
    var template = document.querySelector( ".lightning-bundle-child-product-display-template" );
    var selects  = document.querySelectorAll( ".lightning-bundle-option-select" );
    var variants = {}
    for( var i = 0; i < selects.length; i++ )
    {
        var select         = selects[ i ];
        var parent         = select.closest( '.lightning-bundle-row' );
        var quantity       = parent.querySelector( '.lightning-bundle-qty-select' );
        quantity           = quantity.options[ quantity.selectedIndex ].value;
        var selectedOption = select.options[ select.selectedIndex ];
        if( variants[ selectedOption.value ] )
        {
            variants[ selectedOption.value ].count = variants[ selectedOption.value ].count + quantity;
        }
        else
        {
            variants[ selectedOption.value ] = {
                title : selectedOption.dataset.title,
                sku   : selectedOption.dataset.sku,
                count : quantity
            }
        }
    }
    Object.keys( variants ).forEach( function( key )
    {
        var clone = template.cloneNode();
        clone.setAttribute( "name", `properties[${variants[ key ].title}]` );
        clone.value = variants[ key ].count;
        clone.setAttribute( "class", "lightning-bundle-child-product-display" );
        template.parentElement.insertBefore( clone, template );
    });
}

function HandleBundleOptionSelectChange( e )
{
    var select              = e.currentTarget;
    var bundleOption        = select.dataset.bundleOption;
    if( !bundleOption )
    {
        var bundleOption = select.closest( "[data-bundle-option]" ).dataset.bundleOption;
    }
    var inputForSelect      = document.querySelector( ".lightning-bundle-child-product-input[data-bundle-option='" + bundleOption + "']" );
    inputForSelect.setAttribute( "value", select.value );

    CreateSkuDisplayProperties();
}


function HandleShowBundleSelectClick()
{
    var nextSelect = document.querySelector( ".lightning-bundle-option-row.bundle-hidden" );

    if( nextSelect )
    {
        nextSelect.classList.remove( "bundle-hidden" );
    }

    HandleQtyPrompt( 1 );
}

function HandleQtyPrompt( qty )
{
    var promptText      = document.querySelector( ".lightning-bundle-remaining-qty-count" );
    if( promptText )
    {
        var targetAmount    = Number( promptText.getAttribute( "data-target-qty" ) );
        var qtySelects      = document.querySelectorAll( ".bundle-form .lightning-bundle-option-row:not(.bundle-hidden) .lightning-bundle-qty-select" )
        var totalQuantity   = 0;

        for( var i = 0; i < qtySelects.length; i++ )
        {
            var qtySelect = qtySelects[ i ];
            totalQuantity += Number( qtySelect.value );
        }

        var promptTextQty       = promptText.querySelector( ".lightning-bundle-qty-left" );
        var qtyOkText           = promptText.querySelector( ".lightning-bundle-qty-success" );
        var qtyErrText          = promptText.querySelector( ".lightning-bundle-qty-error" );
        if( ( targetAmount - totalQuantity ) < 0 )
        {
            qtyOkText.classList.add( "bundle-hidden" );
            qtyErrText.classList.remove( "bundle-hidden" );
            qtyErrText.querySelector( ".lightning-bundle-qty-remove" ).innerText = Math.abs( targetAmount - totalQuantity );
        }
        else
        {
            qtyOkText.classList.remove( "bundle-hidden" );
            qtyErrText.classList.add( "bundle-hidden" );
            promptTextQty.innerText = targetAmount - totalQuantity;
        }

        if( totalQuantity == targetAmount )
        {
            HandleBundleATC( "enable" );
        }
        else
        {
            HandleBundleATC( "disable" );
        }
    }
}

function HandleLightningBundleQtySelectChange( select )
{
    var selectedOption = select.options[ select.selectedIndex ];
    for( var i = 0; i < select.options.length; i++ )
    {
        var option = select.options[ i ];
        option.removeAttribute( "selected" );

        if( option.value == selectedOption.value )
        {
            option.setAttribute( "selected", "selected" );
        }
    }

    HandleQtyPrompt( Number( select.value ) );
}

function HandleBundleATC( cmd )
{
    var button = document.querySelector( ".product-info__add-button button" );

    if( cmd == "enable" )
    {
        button.removeAttribute( "disabled" );
    }
    else
    {
        button.setAttribute( "disabled", "disabled" );
    }
}

function HandleBundleWithRowQtySubmitClick( e )
{
    e.preventDefault();

    AlignRowQtyWithAttributes();
    return true;
}

function AlignRowQtyWithAttributes()
{
    var bundleRows          = document.querySelectorAll( ".lightning-bundle-option-row:not(.bundle-hidden)" );
    var cartAttributeInputs = document.querySelectorAll( ".lightning-bundle-child-product-input" );
    var inputCounter    = 0;
    for( var i = 0; i < bundleRows.length; i++ )
    {
        var bundleRow   = bundleRows[ i ];
        var rowQty      = bundleRow.querySelector( ".lightning-bundle-qty-select" ).value;
        var select = bundleRow.querySelector( ".lightning-bundle-option-select" );
        if( select)
        {
            var value = select.value;
        }
        else
        {
            var value = bundleRow.querySelector( ".lightning-bundle-pill-input:checked" ).value;
        }
        var rowVariant = value;

        for( var j = 0; j < rowQty; j++ )
        {
            cartAttributeInput = cartAttributeInputs[ inputCounter ];
            cartAttributeInput.setAttribute( "value", rowVariant );

            inputCounter++;
        }
    }
}

window.addEventListener( "DOMContentLoaded", function( event )
{
    document.querySelector( '.product-info__add-button button' ).addEventListener( "click", function( e )
    {
        var formParent  = document.querySelector( ".bundle-form" );
        var formID      = formParent.getAttribute( "form-id" );
        if( formParent.classList.contains( "lightning-set-bundle" ) )
        {
            HandleBundleWithRowQtySubmitClick( e );
            HandleBundleCTAClick( e );
            document.querySelector( "#" + formID ).submit();

        }
        else
        {
            HandleBundleCTAClick( e );
            document.querySelector( "#" + formID ).submit();
        }
    } );

    document.querySelectorAll( '.lightning-bundle-option-select, .lightning-bundle-pill-input' ).forEach( el =>
    {
        el.addEventListener( "change", function( e )
        {
            HandleBundleOptionSelectChange( e );
        } );
    } );

    if( document.querySelector( '.lightning-bundle-show-next-select' ) )
    {
        document.querySelector( '.lightning-bundle-show-next-select' ).addEventListener( "click", function( e )
        {
            HandleShowBundleSelectClick( e );
        } );
    }

    document.querySelectorAll( '.lightning-bundle-qty-select' ).forEach( el =>
    {
        el.addEventListener( "change", function( e )
        {
            HandleLightningBundleQtySelectChange( e.currentTarget );
        } );
    }) ;

    document.querySelectorAll( '.lightning-bundle-pills-button' ).forEach( el =>
    {
        el.addEventListener( "click", function( e )
        {
            HandleBundlePillClick( e );
        } );
    } );

    HandleQtyPrompt( );

    CreateSkuDisplayProperties( );
} );